import { render, staticRenderFns } from "./Loyalties.vue?vue&type=template&id=d2aa45a6&"
import script from "./Loyalties.vue?vue&type=script&lang=js&"
export * from "./Loyalties.vue?vue&type=script&lang=js&"
import style0 from "./Loyalties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Loyalties.vue"
export default component.exports